import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Form,
  Container,
  Row,
  Col,
} from "reactstrap";
import { useContext, useEffect, useState } from "react";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import InputStandard from "../../components/Inputs/InputStandard";
import { jwtDecode } from "jwt-decode";
import { UserToken } from "../../context/hooks/useAuth";
import MenuTop from "../../components/MenuTop/MenuTop";
import { SettingsContext } from "../../context/SettingsContext";
import exemploEmailPreview from "../../assets/img/brand/exemplo-email-config.png";
import "./Settings.css";

const Settings = () => {
  const {
    updateMessageTitle,
    setMessageTitle,
    messageTitle,
    getMessageTitleByUserId,
    setMessageEmailBody,
    messageEmailBody,
  } = useContext(SettingsContext);
  const user = jwtDecode(localStorage.getItem("token") || "") as UserToken;

  useEffect(() => {
    const getData = async () => {
      await getMessageTitleByUserId(user.UserId);
    };
    getData();
  }, []);

  const [editPerfilState, setEditPerfilState] = useState<boolean>(true);

  const handleBlur = (valueAtt: any, name: string) => {
    setMessageTitle(valueAtt);
  };

  const handleBlurEmailBody = (valueAtt: any, name: string) => {
    setMessageEmailBody(valueAtt);
  };

  return (
    <>
      <ToastContainer />
      <MenuTop />
      <LoadingSpinner />
      <Container className="mt-3" fluid>
        <Row className="d-flex justify-content-center">
          <Col className="order-xl-1" xl="12">
            <Card className="shadow" style={{ backgroundColor: "#00000000" }}>
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <div className="col-6 xs-8">
                    <span className="settings-title">
                      Configurações de E-mail para Envio de Documentos
                    </span>
                  </div>
                  <Col
                    className="text-right col-6 d-flex justify-content-end"
                    xs="4"
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        width: "50%",
                      }}
                    >
                      {editPerfilState ? (
                        <Button
                          className="settings-btn-edit"
                          onClick={(e) => setEditPerfilState(false)}
                          size="sm"
                        >
                          Editar Configurações
                        </Button>
                      ) : (
                        <>
                          <Button
                            className="settings-btn-save"
                            style={{ flexGrow: 1 }}
                            size="sm"
                            onClick={() => {
                              updateMessageTitle(messageTitle, messageEmailBody);
                              setEditPerfilState(true);
                            }}
                          >
                            Salvar edições
                          </Button>
                          <Button
                            className="settings-btn-cancel"
                            style={{ flexGrow: 1 }}
                            onClick={() => {
                              setEditPerfilState(true);
                              getMessageTitleByUserId(user.UserId);
                            }}
                            size="sm"
                          >
                            Cancelar
                          </Button>
                        </>
                      )}
                    </div>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody style={{ backgroundColor: "#ffffff" }}>
                <Form>
                  <h6 className="heading-small text-muted mb-4">
                    PERSONALIZAÇÃO DO E-MAIL
                  </h6>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="6" className="mb-4">
                        <InputStandard
                          handleChange={handleBlur}
                          name="name"
                          label={
                            "Assunto do E-mail (Título exibido no e-mail enviado aos signatários)"
                          }
                          value={messageTitle}
                          disabled={editPerfilState}
                        ></InputStandard>
                      </Col>
                      <Col lg="6">
                        <InputStandard
                          handleChange={handleBlurEmailBody}
                          name="emailBody"
                          label={
                            "Mensagem do Corpo do E-mail (opcional - instruções ou saudação aos signatários)"
                          }
                          value={messageEmailBody}
                          disabled={editPerfilState}
                        ></InputStandard>
                      </Col>
                    </Row>
                  </div>

                  <hr className="my-4" />

                  <div className="pl-lg-4 settings-email-example">
                    <h6 className="heading-small text-muted mb-2">
                      EXEMPLO DE VISUALIZAÇÃO
                    </h6>
                    <p className="settings-email-example-caption mb-3">
                      Veja onde o assunto e a mensagem personalizada aparecem no
                      e-mail enviado aos signatários (demais trechos são fixos do
                      modelo).
                    </p>
                    <div className="settings-email-preview">
                      <img
                        src={exemploEmailPreview}
                        alt="Exemplo de e-mail: assunto no topo e mensagem no corpo, acima do aviso e do botão de visualizar documento"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Settings;
